import { z } from "zod";
import { TaskType } from "@remi/enums/task-type";

export const ReviewRevenueTaskAttemptSchema = z.object({
  type: z.literal(TaskType.REVIEW_REVENUE),
  projectId: z.number(),
  invoiceBidRequestId: z.string().nullish(),
  invoiceSubmissionNotes: z.string().max(250, "Invoice submission notes must be 250 characters or less").nullish(),
  shouldSkipInvoiceAutomation: z.boolean().optional(),
  invoicePerPvSystem: z.boolean().optional(),
  pvSystemBidRequestIds: z.record(z.string(), z.string().nullish()).optional(),
});

export type ReviewRevenueTaskAttempt = z.infer<typeof ReviewRevenueTaskAttemptSchema>;
